module.exports = __webpack_public_path__ + "img/30.dc9fa11c.jpg";